module.exports = __webpack_public_path__ + "static/media/download-middle-banner.df4cbbc0.png";